import React from 'react';
interface Props<T> {
  cardContent: Array<T>;
  cardTemplate: (item: T) => React.ReactNode;
}

const CardsList = <T,>(props: Props<T>) => {
  const { cardContent, cardTemplate } = props;

  return (
    <div
      id="cards-list-wrapper"
      data-testid="cards-list-wrapper"
      className="flex h-full w-full flex-col overflow-y-auto px-2 py-2"
    >
      {cardContent.map((item, index) => (
        <div
          id="cards-list-content"
          data-testid="cards-list-content"
          key={index}
          className={`border-solid border-[1px] border-[#B4B4B4] bg-white rounded-[4px] ${
            index < cardContent.length - 1 ? 'mb-2' : ''
          }`}
        >
          {cardTemplate(item)}
        </div>
      ))}
    </div>
  );
};

export default CardsList;
